import { createStore, applyMiddleware } from 'redux';
import { useDispatch } from 'react-redux';
import reducers from './reducers/reducers';
import middlewares from './middlewares/middlewares'

import { IFieldsState } from './actions/fields.actions';
import { ISecurityState } from './actions/security.actions';
import { SettingState } from './actions/settings.actions';
import { ThemeState } from './actions/themes.actions';

import { updateTheme } from './middlewares/themes.middleware';

import { persistedState, saveState } from './persisted.store';
import { getDefaultMiddleware } from '@reduxjs/toolkit';
import { IPredictionsState } from './actions/predictions.actions';
import { ISocketsState } from './actions/sockets.actions';

export interface ApplicationState {
    fields: IFieldsState,
    predictions: IPredictionsState,
    security: ISecurityState,
    settings: SettingState,
    sockets: ISocketsState,
    theme: ThemeState,
}

function configureStore() {

    const store = createStore(
        reducers,
        persistedState, // second argument overrides the initial state
        applyMiddleware(
            ...getDefaultMiddleware(),
            ...middlewares
        )
    );

    // add a listener that will be invoked on any state change
    store.subscribe(() => {
        saveState(store.getState());
    });

    // Update the initial theme
    updateTheme(store.getState())

    // Debugging subscription
    store.subscribe(() => {
        console.log('store-state', store.getState());
    });

    return store;
}

const store = configureStore();
export default store;
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>() // Export a hook that can be reused to resolve types
